import invariant from 'invariant'
import _ from 'lodash'

function valueInterpolateMapping({
  inValues,
  outValues,
  value,
}: {
  inValues: number[]
  outValues: number[]
  value: number
}): number {
  let index = _.findIndex(inValues, (item, index) => {
    if (value <= item) return true

    const nextItem = inValues[index + 1]
    if (!nextItem) return false

    if (value < nextItem) return true

    return false
  })

  invariant(index !== -1, 'index for inValues is not found')

  let itemInValues = inValues[index]
  let itemOutFirst = outValues[index]

  let itemNextInValues = inValues[index + 1]
  let itemOutNext = outValues[index + 1]
  if (!itemNextInValues) return itemOutFirst

  let kof = (value - itemInValues) / (itemNextInValues - itemInValues)
  // console.log('kof', index, kof)

  let itemOutValue = itemOutFirst + (itemOutNext - itemOutFirst) * kof

  return itemOutValue
}

window.valueInterpolateMapping = valueInterpolateMapping
// const val1 = valueInterpolateMapping({
//   inValues: [1, 11],
//   outValues: [40, 60],
//   value: 3,
// })

// console.log('valueInterpolateMapping', val1)

export default valueInterpolateMapping
